"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var prepareRewards_1 = __importDefault(require("./prepareRewards"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var useTableData = function (rewards) {
    var t = (0, next_intl_1.useTranslations)('lottery');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var preparedRewards = (0, prepareRewards_1.default)({
        rewards: rewards || [],
    });
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'place',
                    label: t('place'),
                },
                {
                    field: 'prize',
                    label: t('prize'),
                },
                {
                    field: 'player',
                    label: t('player'),
                },
            ],
            rows: [],
        };
        table.rows = preparedRewards.map(function (item) {
            if (!item)
                return null;
            return {
                place: react_1.default.createElement("span", null, item.place),
                prize: (react_1.default.createElement("span", null,
                    String((item === null || item === void 0 ? void 0 : item.cash)
                        ? item.cash
                        : (item === null || item === void 0 ? void 0 : item.freeSpins)
                            ? "".concat(item.freeSpins)
                            : item.stuffReward
                                ? item.stuffReward || ''
                                : '').toLocaleUpperCase(),
                    String((item === null || item === void 0 ? void 0 : item.bonus) ? item === null || item === void 0 ? void 0 : item.bonus : '').toUpperCase())),
                player: react_1.default.createElement("span", null, item === null || item === void 0 ? void 0 : item.username),
                className: (item === null || item === void 0 ? void 0 : item.me) ? styles_module_scss_1.default.highlightRow : '',
            };
        });
        return table;
    }, [t, preparedRewards]);
};
exports.useTableData = useTableData;
